import APIService from "@/services/APIService.js";

const apiNivelUsuario = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/nivel-usuario"
});

export default {
  getAll() {
    return apiNivelUsuario.get();
  }
};
